import React, { useRef } from 'react';
import classNames from 'classnames';
import { useCheckbox } from '@react-aria/checkbox';
import { useFocusRing } from '@react-aria/focus';
import { useVisuallyHidden } from '@react-aria/visually-hidden';
import { COLORS, Icon } from 'Permafrost/index';
import { StyledCheckbox } from './Checkbox.styles';
/**
 * A single checkbox and its label.
 */
export function Checkbox(props) {
    const { checkmarkColor = COLORS.black, children, className, color = COLORS.white, id, isDisabled, isLoading = false, isSelected = false, isInline = false, onChange = () => { }, } = props;
    const inputRef = useRef(null);
    const checkboxState = {
        isSelected,
        setSelected: onChange,
        toggle: () => onChange(!isSelected),
    };
    const { inputProps } = useCheckbox(props, checkboxState, inputRef);
    const { isFocusVisible, focusProps } = useFocusRing();
    const { visuallyHiddenProps } = useVisuallyHidden();
    const checkboxMeasure = 18;
    return (React.createElement(StyledCheckbox, { "data-cy": props['data-cy'], "data-tip": props['data-tip'], "data-for": props['data-for'], className: classNames({ checked: isSelected, disabled: isDisabled || isLoading, inline: isInline }, className), id: id, "$color": color, "$checkmarkColor": checkmarkColor },
        React.createElement("input", Object.assign({ type: "checkbox" }, inputProps, visuallyHiddenProps, focusProps, { ref: inputRef, disabled: isDisabled || isLoading })),
        React.createElement("svg", { viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", overflow: "visible", className: "checkbox" },
            React.createElement("rect", { x: 1, y: 1, width: checkboxMeasure, height: checkboxMeasure, rx: 2, fill: "none", stroke: "currentColor", className: "checkboxSquare" }),
            isFocusVisible && (React.createElement("rect", { x: -2.5, y: -2.5, width: checkboxMeasure + 7, height: checkboxMeasure + 7, rx: 4, fill: "none", className: "focusRing" })),
            React.createElement("g", { transform: "translate(1, 1)" }, isSelected && React.createElement(Icon, { name: "check", className: "checkmark", size: [checkboxMeasure] }))),
        children ? React.createElement("span", { className: "checkbox__text" }, children) : null));
}
//# sourceMappingURL=Checkbox.js.map